import type { ComponentConfig } from '@puckeditor/core'
import { backgroundStyleField, borderStyleField } from '../../fields/StyleFields'

/**
 * Injects background + border fields (and defaultProps) into a component config.
 * Does NOT add any wrapper element — each component's own render must read
 * props.background / props.border and apply applyStyleProps() to its root element.
 */
export function withStyleFields<
  ThisComponentConfig extends ComponentConfig<any> = ComponentConfig,
>(componentConfig: ThisComponentConfig): ThisComponentConfig {
  const originalResolveFields = componentConfig.resolveFields

  return {
    ...componentConfig,
    fields: {
      ...componentConfig.fields,
      background: backgroundStyleField,
      border: borderStyleField,
    },
    defaultProps: {
      background: {},
      border: {},
      ...componentConfig.defaultProps,
    },
    ...(originalResolveFields
      ? {
          resolveFields: (data: any, params: any) => {
            const resolved = originalResolveFields(data, params)
            return {
              ...resolved,
              background: backgroundStyleField,
              border: borderStyleField,
            }
          },
        }
      : {}),
  }
}
